import React from 'react';

const IcGroup = ({ fill = '#ADADAD' }: { fill?: string }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='37' height='41' viewBox='0 0 37 41' fill='none'>
      <path
        d='M26.0359 17.6875C26.0359 16.8245 25.3363 16.125 24.4734 16.125H8.37961C7.51664 16.125 6.81711 16.8245 6.81711 17.6875C6.81711 18.5505 7.51664 19.25 8.37961 19.25H24.4734C25.3363 19.25 26.0359 18.5505 26.0359 17.6875Z'
        fill={fill}
      />
      <path
        d='M8.37961 22.375C7.51664 22.375 6.81711 23.0745 6.81711 23.9375C6.81711 24.8005 7.51664 25.5 8.37961 25.5H18.1539C19.0169 25.5 19.7164 24.8005 19.7164 23.9375C19.7164 23.0745 19.0169 22.375 18.1539 22.375H8.37961Z'
        fill={fill}
      />
      <path
        d='M12.0515 37.375H6.82578C5.10265 37.375 3.70078 35.9731 3.70078 34.25V6.75C3.70078 5.02688 5.10265 3.625 6.82578 3.625H26.0359C27.759 3.625 29.1609 5.02688 29.1609 6.75V16.3594C29.1609 17.2223 29.8604 17.9219 30.7234 17.9219C31.5863 17.9219 32.2859 17.2223 32.2859 16.3594V6.75C32.2859 3.30375 29.4821 0.5 26.0359 0.5H6.82578C3.37953 0.5 0.575775 3.30375 0.575775 6.75V34.25C0.575775 37.6962 3.37953 40.5 6.82578 40.5H12.0515C12.9144 40.5 13.614 39.8005 13.614 38.9375C13.614 38.0745 12.9144 37.375 12.0515 37.375Z'
        fill={fill}
      />
      <path
        d='M35.0534 23.1229C33.2258 21.2952 30.252 21.2951 28.4255 23.1216L19.8472 31.681C19.665 31.8628 19.5306 32.0867 19.4558 32.333L17.5876 38.4834C17.422 39.0287 17.5663 39.6208 17.9642 40.0287C18.2623 40.3342 18.6673 40.5001 19.0827 40.5001C19.2217 40.5001 19.362 40.4815 19.4998 40.4433L25.8064 38.6963C26.0659 38.6244 26.3025 38.4867 26.4931 38.2964L35.0535 29.7521C36.8812 27.9244 36.8812 24.9507 35.0534 23.1229ZM24.5762 35.7944L21.4034 36.6734L22.332 33.6164L28.1202 27.841L30.3303 30.0512L24.5762 35.7944ZM32.8449 27.5415L32.5422 27.8436L30.3324 25.6338L30.6341 25.3327C31.2434 24.7235 32.2346 24.7235 32.8438 25.3327C33.453 25.9419 33.453 26.9332 32.8449 27.5415Z'
        fill={fill}
      />
      <path
        d='M24.4734 9.875H8.37961C7.51664 9.875 6.81711 10.5745 6.81711 11.4375C6.81711 12.3005 7.51664 13 8.37961 13H24.4734C25.3363 13 26.0359 12.3005 26.0359 11.4375C26.0359 10.5745 25.3363 9.875 24.4734 9.875Z'
        fill={fill}
      />
    </svg>
  );
};

export default IcGroup;
